module.exports = __webpack_public_path__ + "static/media/star--illustrated.49e19c63.svg";